import styled, { css } from "styled-components";
import { Link } from "react-scroll";

export const NavbarContainer = styled.nav`
  ${(props) => css`
    background-color: ${props.extendNavbar
      ? props.theme.colors.blackColorBlur
      : props.theme.colors.blackColor};
  `}
  position: ${(props) => props.positionNavbar};
  top: ${(props) => (props.extendNavbar ? "0" : "")};
  height: ${(props) => (props.extendNavbar ? "100vh" : "80px")};
  z-index: 2;
  width: 100%;
  display: flex;
  flex-direction: column;
`;

export const LeftContainer = styled.div`
  flex: 70%;
  display: flex;
  align-items: center;
  padding-left: 5%;
`;

export const RightContainer = styled.div`
  flex: 30%;
  display: flex;
  justify-content: flex-end;
  padding-right: 50px;
`;

export const NavbarInnerContainer = styled.div`
  width: 100%;
  height: 80px;
  display: flex;
`;

export const NavbarLinkContainer = styled.div`
  display: flex;
  text-align: center;
`;

export const NavbarLink = styled(Link)`
  color: #ccc;
  cursor: pointer;
  padding: 5px;
  font-size: 1.2rem;
  font-weight: 600;
  text-decoration: none;
  margin: 10px;
  display: inline-block;

  &:after {
    display: block;
    content: "";
    border-bottom: solid 3px #019fb6;
    transform: scaleX(0);
    transition: transform 250ms ease-in-out;
  }

  &:hover {
    color: #fff;
  }

  &:hover:after {
    transform: scaleX(1);
  }

  &:hover:after {
    transform-origin: 0% 50%;
  }

  @media (max-width: 700px) {
    display: none;
  }
`;

export const NavbarLinkExtended = styled(Link)`
  color: white;
  cursor: pointer;
  padding: 5px;
  font-size: x-large;
  text-decoration: none;
  margin: 10px;

  &:after {
    display: block;
    content: "";
    border-bottom: solid 3px #019fb6;
    transform: scaleX(0);
    transition: transform 250ms ease-in-out;
  }

  &:hover {
    color: #fff;
  }

  &:hover:after {
    transform: scaleX(1);
  }

  &:hover:after {
    transform-origin: 0% 50%;
  }
`;

export const OpenLinksButton = styled.button`
  ${({ theme }) => css`
    background-color: ${theme.colors.buttonColor};
  `}
  padding: 5px;
  border-radius: 5px;
  border: none;
  outline: none;
  color: white;
  cursor: pointer;
  display: flex;

  svg {
    font-size: 2em;
  }

  @media (min-width: 700px) {
    display: none;
  }
`;

export const NavbarExtendedContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  @media (min-width: 700px) {
    display: none;
  }
`;
